import { ModalConfirm } from '@you-go-vn/components';
import { DeleteOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';

type Props = {
  title: string | ReactNode;
  message?: string | ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  deleteModalVisible: boolean;
};
export const ModalConfirmDelete = ({
  title,
  message,
  deleteModalVisible,
  onConfirm,
  onCancel,
}: Props) => {
  return (
    <ModalConfirm
      visible={deleteModalVisible}
      confirm
      type="danger"
      icon={<DeleteOutlined />}
      title={title}
      confirmText="Đồng ý xoá"
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      {message}
    </ModalConfirm>
  );
};
